import React from 'react';
import BaseQuestion from './BaseQuestion';
import { QUESTION_TYPES } from '../../constants/question-types';

/**
 * Five Star Review question component
 */
const FiveStarReviewQuestion = ({
    question,
    questionIndex,
    onUpdate,
    onRemove,
    onMoveUp,
    onMoveDown,
    isFirst,
    isLast,
}) => {
    return (
        <BaseQuestion
            question={question}
            questionIndex={questionIndex}
            onUpdate={onUpdate}
            onRemove={onRemove}
            onMoveUp={onMoveUp}
            onMoveDown={onMoveDown}
            isFirst={isFirst}
            isLast={isLast}
            questionType={QUESTION_TYPES.FIVE_STAR_REVIEW}
            questionTypeLabel="Five Star Review"
            questionTypeIcon="⭐"
        >
            <div className="mt-3 p-3 bg-light rounded border">
                <div className="d-flex align-items-center gap-1">
                    <span className="text-muted small me-2">Preview:</span>
                    <div className="d-flex gap-1">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <svg
                                key={star}
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="#E0E0E0"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                    transition: 'all 0.2s ease-in-out',
                                }}
                            >
                                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                        ))}
                    </div>
                </div>
                <small className="text-muted d-block mt-2">
                    Users will be able to rate from 1 to 5 stars
                </small>
            </div>
        </BaseQuestion>
    );
};

export default FiveStarReviewQuestion;
